export default __webpack_public_path__ + "static/media/no-result.b9b9fe2f.png";